import React from 'react';
import { useLocation } from 'react-router-dom';
import { PlaylistProvider } from '../../components/PlaylistContext';
import { withOrganization } from '../../components/Session';
import FindAudio from './FindAudio';

const PublicFindAudio = (props) => {
  const location = useLocation();
  const subMode = location.pathname === '/public-library' ? 'publicLibrary' : 'masterLibrary';
  return (
    <PlaylistProvider>
      <FindAudio {...props} mode="public" subMode={subMode} location={location} />
    </PlaylistProvider>
  );
};

export default withOrganization(PublicFindAudio);
